import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "./useAuth";
import {
  getLocaleFromPathname,
  getPathSegments,
  normalizeLocale,
  stripLocaleFromPathname,
  withLocalePath,
} from "../utils/localeRouting";

export const useLocalizedNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { language } = useAuth();

  const locale = normalizeLocale(
    getLocaleFromPathname(location.pathname) || language
  );

  const localizePath = useCallback(
    (path) => withLocalePath(path, locale),
    [locale]
  );

  const navigateLocalized = useCallback(
    (path, options) => navigate(withLocalePath(path, locale), options),
    [locale, navigate]
  );

  return {
    locale,
    localizePath,
    navigateLocalized,
    pathnameWithoutLocale: stripLocaleFromPathname(location.pathname),
    pathSegments: getPathSegments(location.pathname),
  };
};
